window.sdkInterface = {
    //js向java发送消息
    //jsonString格式如下。functionName要调用的函数的名称，params传递过去的参数
    // {
    //     "functionName":"exitGame",
    //     "params":{
    //          "param1":1,
    //          "param2":"xxx"
    //     }
    // }
    SDKCall : function(jsonString)
    {
        //js调用JAVA
        //通过window.prompt即可与java通信,仅处理第二个参数为"JsCallPlatform"的消息
        //JsCallPlatform禁止修改。
        var result = window.prompt(jsonString,"JsCallPlatform");
        console.log("SDKCall result:" + result);
        return result;
    },

    EnterGame : function()
    {
        var jsonObj = {
            "functionName":"enterGame",
            "params":""
        }
        var jsonString = JSON.stringify(jsonObj);
        return sdkInterface.SDKCall(jsonString);
    },

    ExitGame : function()
    {
        var jsonObj = {
            "functionName":"exitGame",
            "params":""
        }
        var jsonString = JSON.stringify(jsonObj);
        return sdkInterface.SDKCall(jsonString);
    },
    //震动(time震动时间：毫秒)
    vibratePhone : function(time)
    {
        console.log("vibratePhone")
        var paramObj = {
            "time":time
        }
        var jsonObj = {
            "functionName":"vibrate",
            "params":paramObj
        }
        var jsonString = JSON.stringify(jsonObj);
        return sdkInterface.SDKCall(jsonString);
    },
}




